import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { BranchData } from "@/features/cards/types/CardDetails.type";
import type { CompanyData } from "@/features/companies/types/companies.type";
import { CompanyBranchData } from "@/features/privateCompanies/types/companyBranches.type";
import { BriefcaseBusinessIcon, ChevronsRight } from "lucide-react";

type CardDetailCompanyInformationProps = {
  companyData?: CompanyData;
  companyBranch?: BranchData | CompanyBranchData;
}

const CardDetailCompanyInformation = ({ companyData, companyBranch }: CardDetailCompanyInformationProps) => {
  return (
    <div className="flex items-center gap-2">
      <ImageWithPlaceholder
        placeholderIcon={BriefcaseBusinessIcon}
        url={companyData?.general_information?.company_logo?.url}
        className="size-9"
        iconClassName="size-6"
      />

      <p className="text-[22px] font-bold">
        {companyData?.general_information?.fantasy_name || companyData?.general_information?.official_name}
      </p>

      {companyBranch && (
        <>
          <ChevronsRight color='#ffffffb3' />

          <p data-testid='company_display_name' className="text-xl italic font-light">
            {companyBranch?.display_name}
          </p>
        </>
      )}
    </div>
  )
}

export default CardDetailCompanyInformation;
